/* ------------------------------------------------------------------------
   card-price - preco do card no padrao da pagina de produto (3 linhas):
     1) "de" pequeno e riscado   -> preco de venda (preco_promocao || preco)
     2) headline                 -> preco com desconto a vista + selo "PIX"
     3) parcelamento sem juros   -> "ou R$ X em Nx de R$ Y sem juros"

   Por que ler de badge/DOM em vez da API: /product/list da Webstore NAO
   retorna prices.pix_discount pra esta loja (vem 0 - so /product/view traz).
   A loja publica o percentual e o no de parcelas sem juros nas condicoes
   ("Pague no Pix - 8% de descontos" / "Parcele as compras - 4X sem juros"),
   entao usamos isso como fonte. Quando a API passar a mandar desconto_avista
   no /product/list, o valor do produto tem prioridade (ver pixPctFor()).
   ------------------------------------------------------------------------ */
(function () {
  var CFG = { pixPct: 0, semJurosN: 0, ready: false };
  var NBSP = String.fromCharCode(160);

  function fmt(v) {
    try {
      return Number(v).toLocaleString('pt-br', {
        style: 'currency', currency: 'BRL', minimumFractionDigits: 2
      });
    } catch (e) { return 'R$ 0,00'; }
  }

  function parsePrice(txt) {
    if (!txt) return 0;
    var s = String(txt).split(' ').join('').split(NBSP).join('');
    var m = s.match(/(\d[\d.]*,\d{2})/);
    if (!m) return 0;
    return Number(m[1].split('.').join('').replace(',', '.')) || 0;
  }

  function storeConds() {
    try {
      /* 1) SSR injeta window.__WS_SERVER_DATA__.storeInfo (sincrono, em toda pagina) */
      var sd = window.__WS_SERVER_DATA__ && window.__WS_SERVER_DATA__.storeInfo;
      var c = sd && (sd.conditions || sd.condicoes);
      if (Array.isArray(c) && c.length) return c;
      /* 2) infoLoja normalizada (so em paginas com ancora de condicao, ex. home) */
      var g = window.wsMain && wsMain.globalData && wsMain.globalData.infoLoja;
      c = g && (g.condicoes || g.conditions);
      return Array.isArray(c) ? c : [];
    } catch (e) { return []; }
  }

  /* infoLoja (com as condicoes) so e carregada nas paginas que tem ancora de
     condicao (home). Nas outras, dispara a mesma chamada padrao aqui. */
  function ensureInfoLoja(cb) {
    if (storeConds().length) { cb && cb(); return; }
    try {
      if (CFG._fetching) return;
      if (window.ApiWS && ApiWS.Calls && typeof ApiWS.Calls.infosLojas === 'function') {
        CFG._fetching = true;
        Promise.resolve(ApiWS.Calls.infosLojas())
          .then(function () { CFG._fetching = false; cb && cb(); })
          .catch(function () { CFG._fetching = false; });
      }
    } catch (e) { CFG._fetching = false; }
  }

  function loadCfg() {
    var conds = storeConds();
    if (!conds.length) return false;
    conds.forEach(function (cond) {
      var t = ((cond.titulo || cond.title || '') + ' ' +
               (cond.subtitulo || cond.subtitle || '')).toLowerCase();
      if (t.indexOf('pix') !== -1 && !CFG.pixPct) {
        var mp = t.match(/(\d{1,2})\s*%/);
        if (mp) CFG.pixPct = Number(mp[1]);
      }
      if ((t.indexOf('sem juros') !== -1 || t.indexOf('parcele') !== -1 ||
           t.indexOf('parcela') !== -1) && !CFG.semJurosN) {
        var ms = t.match(/(\d{1,2})\s*x/);
        if (ms) CFG.semJurosN = Number(ms[1]);
      }
    });
    CFG.ready = true;
    return true;
  }

  /* Todos os produtos que o client-side conhece (raramente disponivel quando
     a listagem veio 100% do SSR - ai caimos no percentual da loja). */
  function findProd(sku) {
    if (!sku) return null;
    sku = String(sku).trim();
    var g = (window.wsMain && wsMain.globalData) || {};
    var lists = [];
    var push = function (l) { if (Array.isArray(l)) lists = lists.concat(l); };
    if (g.infoProduto) lists.push(g.infoProduto);
    push(g.listHomeProds && g.listHomeProds.produtos);
    push(g.listCategoryProds && g.listCategoryProds.produtos);
    push(g.listRelatedProds);
    push(g.listLastProds);
    push(g.listPreviousProds);
    if (g.listGroupProds && Array.isArray(g.listGroupProds.grupos)) {
      g.listGroupProds.grupos.forEach(function (gr) { push(gr && gr.produtos); });
    }
    return lists.find(function (p) {
      return p && String(p.codigo || p.cod || p.sku || '').trim() === sku;
    }) || null;
  }

  function pixPctFor(prod) {
    var d = prod && prod.precos && Number(prod.precos.desconto_avista);
    if (d && d > 0) return d;              /* futuro: quando a API mandar */
    return CFG.pixPct || 0;                /* hoje: condicao da loja */
  }

  function buildHTML(base, regular, pixPct, semJurosN) {
    if (!base) return '';
    var deLine = '';
    if (pixPct > 0) deLine = fmt(base);
    else if (regular > base) deLine = fmt(regular);

    var headline = pixPct > 0
      ? fmt(base - (base * pixPct / 100)) + ' <span class="cardpr-pix">PIX</span>'
      : fmt(base);

    var parc = '';
    if (semJurosN >= 2) {
      parc = 'ou ' + fmt(base) + ' em ' + semJurosN +
             'x de ' + fmt(base / semJurosN) + ' sem juros';
    }

    return (deLine ? '<span class="cardpr-de">' + deLine + '</span>' : '') +
           '<span class="cardpr-head">' + headline + '</span>' +
           (parc ? '<span class="cardpr-parc">' + parc + '</span>' : '');
  }

  function applyCard(card) {
    if (!card) return;
    var box0 = card.querySelector('.prod-showcase-price-container');
    if (!box0) return;
    if (card.matches('.unavailable, .unavaliable, .consult')) return;
    if (box0.querySelector('.prod-unavaliable-message, .prod-consult-message')) return;

    var sellEl = box0.querySelector('.prod-showcase-price-sell');
    var offEl  = box0.querySelector('.prod-showcase-price-off');
    var base = parsePrice(sellEl && sellEl.textContent);
    var regular = parsePrice(offEl && offEl.textContent);
    if (!base) return;

    var prod = findProd(card.getAttribute('ws-prod-sku') || card.getAttribute('data-prod-sku'));
    var pixPct = pixPctFor(prod);

    var html = buildHTML(base, regular, pixPct, CFG.semJurosN);
    if (!html) return;

    var box = null, kids = box0.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].className && kids[i].className.indexOf('cardpr-box') !== -1) { box = kids[i]; break; }
    }
    if (!box) {
      box = document.createElement('div');
      box.className = 'cardpr-box';
      box0.insertBefore(box, box0.firstChild);
    }
    if (box.getAttribute('data-h') === html) return;
    box.innerHTML = html;
    box.setAttribute('data-h', html);
    box0.classList.add('cardpr-on');
  }

  function run(root) {
    if (!CFG.ready) {
      loadCfg();
      if (!CFG.ready) ensureInfoLoja(function () { loadCfg(); run(); });
    }
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.prod-showcase-holder').forEach(applyCard);
  }

  function boot() {
    run();
    [300, 800, 1500, 2500, 4000].forEach(function (t) { setTimeout(run, t); });
    try {
      var mo = new MutationObserver(function (muts) {
        var hit = false;
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if ((n.matches && n.matches('.prod-showcase-holder')) ||
                (n.querySelector && n.querySelector('.prod-showcase-holder'))) hit = true;
          });
        });
        if (hit) window.requestAnimationFrame(function () { run(); });
      });
      if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { run(); });
})();
